import React from 'react';
import { Icon } from '../../../../shared/components/Icon';
export const SPLogoCollapsed = () => (React.createElement(Icon, { source: "SPLogoCollapsed", svgStyle: {
        width: '40px',
        height: '40px',
    } }));
//# sourceMappingURL=SPLogoCollapsed.js.map